import React, { useEffect, useState } from "react";
import { useSnackbar } from "react-simple-snackbar";
import InfiniteScroll from "react-infinite-scroll-component";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  FallBack,
  ProposalsList,
  CustomText,
  CategoryNames,
  ConfirmationDialog,
  Image,
  SearchFallBack,
  CustomButton,
  PrimaryCta,
  CustomTextInput,
  FallBackBtn,
} from "../../components";
import Core from "../../common/clientSdk";
import Utils from "../../common/utils";
import { Loader } from "../loader";
import InfluencerDetail from "./influencerDetailScreen";
import ReactGA from "react-ga";
import Icon from "../../components/core_component/icon";
//import { Tooltip as ReactTooltip } from "react-tooltip";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import tr from "date-fns/esm/locale/tr/index.js";
import CustomTable from "../../components/customTable";
import * as CampaignData from "../../common/data/campaign";
import { useDispatch } from "react-redux";
import * as Actions from "../../redux/actions";
import WebStorage from "../../common/web_storage";
import { useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import Select from "react-dropdown-select";
import Style from "../../resources/style";
import { ToastContainer, toast } from "react-toastify";
import CreateCollectionGrid from "../collection/collectionGrid";
import InfluencerDetailModal from "../../modal/influencerDetialModal";
import Sdk from "../../common/core/module";
const options = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "all", label: "All" },
];
const inviteOption = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];
const customBidStyles = {
  headRow: {
    style: {
      backgroundColor: "var(--general-secondary-color)", // Change header background color
      color: "var(--gray-gray-300)", // Change header text color
      fontSize: "14px",
      fontWeight: 600,
      lineHight: "19.2px",
      border: "none",
    },
  },
  headCells: {
    style: {
      padding: "10px 0px 10px 20px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: "14px",
      paddingTop: "5px",
      paddingBottom: "5px",
      fontWeight: 400,
      lineHight: "19.2px",
      "&:hover": {
        backgroundColor: "var(--general-secondary-color)",
        fontWeight: 600,
      },
    },
  },
  cells: {
    style: {
      paddingLeft: "20px",
    },
  },
};

const sortTypes = [
  {
    sortBy: "followers",
    sortOrder: "asc",
    label: "Followers - Low to High",
  },
  {
    sortBy: "followers",
    sortOrder: "desc",
    label: "Followers - High to Low",
  },
];

const limit = 10;
function InviteList(props) {
  const currentUnixDate = Sdk.Campaign.getDateString(new Date());
  const [isLoading, setLoading] = useState(false);
  const [modalIsOpenCollection, setModalIsOpenCollection] = useState(false);
  const [modalIsOpenCollectionGrid, setModalIsOpenCollectionGrid] =
    useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isInviteLoading, setInviteLoading] = useState({});
  const [start, setStart] = useState(0);
  const [next, setNext] = useState(10);
  const [deliveryDate, setDeliveryDate] = useState(currentUnixDate + 604800);
  const [openSnackbar] = useSnackbar();
  const [hoveredIcons, setHoveredIcons] = useState([]);
  const [repostModal, setRepostModal] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchName, setSearchName] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [filterLabel, setFilterLabel] = useState("");
  const [filterDropDown, setFilterDropDown] = useState(false);
  const [influencerFlyOut, setInfluencerFlyOut] = useState(false);
  const [influencerList, setInfluencerList] = useState([]);
  const [influencerInviteList, setInfluencerInviteList] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [bidList, setBidList] = useState();
  const [listLoading, setListLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(null);
  const [influencerId, setInfluencerId] = useState(null);
  const [city, setCity] = useState([]);
  const [state, setState] = useState([]);
  const [profession, setProfession] = useState([]);
  const [invitedMark, setInvitedMark] = useState([]);
  const [influencerGender, setInfluencerGender] = useState([]);
  const [clearFilter, setClearFilter] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const [showCollectionBtn, setShowCollectionBtn] = useState(false);
  const [maxRewardValue, setMaxRewardValue] = useState(null);
  const [filterData, setFilterData] = useState({
    gender: ["male", "female"],
    city: [],
    state: [],
    follower: [],
    category: [],
    profession: [],
    counter: null,
    invite_mark: null,
  });
  const campaignId = props.campaignId;
  var redux_dispatch = useDispatch();
  const navigate = useNavigate();
  const campaignDetail = props.campaignDetail;
  const categoryId =
    campaignDetail?.influencer_data &&
    Object.keys(campaignDetail?.influencer_data?.categories);
  const platformId =
    campaignDetail?.content_type_deep_data &&
    campaignDetail?.content_type_deep_data[0]?.platform_data?.platform_id;

  const campaignStatus = campaignDetail?.campaign_data?.status;
  const genderFilter = campaignDetail?.audience_data?.gender;
  const genderLocation = campaignDetail?.audience_data?.state;
  let cities = CampaignData.CITY.filter((item) => {
    return item.type == "city";
  });

  const redux_selector = useSelector((state) => {
    return {
      BrandUser: state.BrandUserDataReducer,
      Auth: state.BrandUserAuthReducer,
    };
  });
  const { BrandUser = {} } = redux_selector;
  const { brand_deep_data = {} } = BrandUser;

  function updateProgress(status) {
    setLoading(status);
  }

  useEffect(() => {
    if (campaignStatus == "ACTIVE") {
      getBidList();
    }

    setClearFilter(false);
  }, [clearFilter]);

  useEffect(() => {
    if (sortBy) {
      getBidList();
    }
  }, [sortBy, sortOrder]);

  function getBidList() {
    var params = {
      campaign_id: props.campaignId,
    };

    Core.getBidList(
      getBidListSuccess,
      getBidListFailed,
      updateProgress,
      params,
    );
  }

  function getBidListSuccess(response_data) {
    setBidList(response_data["bid_list"]);

    getInfluencerList(response_data["bid_list"], 10);
    getInfluencerInviteList();
  }

  function getBidListFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
    setTotalRows(0);
    setLoading(false);
  }

  function getInfluencerList(bidList, page) {
    let newPage = 0;
    if (page == 10) {
      newPage = 0 * Number(page);
    } else {
      newPage = 10 * Number(page) - 10;
    }

    setListLoading(true);
    setTotalRows(null);
    let filter_data = {
      location: filterData.state,
      gender: filterData.gender,
      profession: filterData.profession,
      is_invited: filterData?.invite_mark?.toString(),
    };
    var params = {
      campaign_id: campaignId,
      //  profession: campaignDetail?.campaign_data?.profession,
      limit: 10,
      start: newPage,
      filter_data: JSON.stringify(filter_data),
    };

    if (sortBy != null) {
      params.sort_by = sortBy;
    }
    if (sortOrder != null) {
      params.sort_order = sortOrder;
    }
    Core.getInfluencerList(
      (...args) => getInfluencerListSuccess(bidList, ...args),
      getInfluencerListFailed,
      updateProgress,
      params,
    );
  }

  function getInfluencerListSuccess(bidList, response_data) {
    // setInfluencerListData(response_data.invite_list);

    if (bidList) {
      let influencerId =
        bidList && bidList?.map((item) => item.bid_data.influencer_id);
      if (response_data.invite_list) {
        const updateList = response_data.invite_list.filter(
          (item) =>
            !influencerId?.includes(item.influencer_data?.influencer_id),
        );
        setInfluencerList(updateList);
      }
    }

    setLoading(false);
    const rawTotal =
      response_data?.total_count ??
      response_data?.pagination_data?.total_count;
    const n =
      rawTotal === null || rawTotal === undefined || rawTotal === ""
        ? NaN
        : Number(rawTotal);
    setTotalRows(Number.isFinite(n) && n >= 0 ? n : 0);
    inviteListFilterFun();
    // const updateList =
    //   response_data &&
    //   response_data?.invite_list.filter((item) =>
    //     bidList?.find(
    //       (data) =>
    //         data.bid_data.influencer_id !== item.influencer_data?.influencer_id
    //     )
    //   );

    setNext(response_data?.pagination_data?.next);
  }

  function getInfluencerListFailed(errorList) {
    toast.error(errorList);
    setInfluencerList([]);
    setTotalRows(0);
    setLoading(false);
  }

  const handlePageChange = (page) => {
    getInfluencerList(bidList, page);
  };

  function getInfluencerInviteList() {
    var params = {
      campaign_id: campaignId,
    };
    Core.getInfluencerInviteList(
      getInfluencerInviteListSuccess,
      getInfluencerInviteListFailed,
      updateProgress,
      params,
    );
  }

  function getInfluencerInviteListSuccess(response_data) {
    setInfluencerInviteList(response_data.invite_list);
  }

  function getInfluencerInviteListFailed(errorList) {
    toast.error(errorList);
    setListLoading(false);
  }
  function createAssignmentAdmin() {
    var params = {
      campaign_id: campaignId,
      org_id: props?.campaignDetail?.brand_data?.org_id,
      influencer_id: influencerId,
      value: maxRewardValue,
      assignment_delivery_date: deliveryDate,
    };
    Core.createAssignmentAdmin(
      createAssignmentAdminSuccess,
      createAssignmentAdminFailed,
      updateProgress,
      params,
    );
  }

  function createAssignmentAdminSuccess(response_data) {
    toast.info("Assignment created successfully!");
    setInfluencerId(null);
    setMaxRewardValue(null);
    closeModal();
  }

  function createAssignmentAdminFailed(errorList) {
    console.log("errorList d", errorList);

    toast.error(errorList.map((item) => item.m).join(", "));
    setListLoading(false);
    closeModal();
  }

  function postInfluencerInvite(influencer_id) {
    var params = {
      campaign_id: campaignId,
      influencer_id: influencer_id,
    };
    Core.postInfluencerInvite(
      postInfluencerInviteSuccess,
      postInfluencerInviteFailed,
      (status) => setInviteLoading({ [influencer_id]: status }),
      params,
    );
  }

  function postInfluencerInviteSuccess(response_data) {
    if (response_data) {
      toast.success("Invitation sent to Influencer");
      getBidList();
      getInfluencerInviteList();
      userSelfData();
    }
  }

  function postInfluencerInviteFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
  }
  function postInfluencerInviteWithdraw(influencer_id) {
    var params = {
      campaign_id: campaignId,
      influencer_id: influencer_id,
    };
    Core.postInfluencerInviteWithdraw(
      postInfluencerInviteWithdrawSuccess,
      postInfluencerInviteWithdrawFailed,
      () => {},
      params,
    );
  }

  function postInfluencerInviteWithdrawSuccess(response_data) {
    toast.success("Invite withdraw");

    getInfluencerList(updateProgress);
    getInfluencerInviteList(updateProgress);
  }

  function postInfluencerInviteWithdrawFailed(errorList) {
    toast.error(errorList);
  }

  function userSelfData() {
    var params = { org_id: brand_deep_data.brand_data.org_id };

    Core.userSelfData(
      userSelfDataSuccess,
      userSelfDataFailed,
      () => {},
      params,
    );
  }

  function userSelfDataSuccess(response_data) {
    redux_dispatch({
      type: Actions.UPDATE_ORG_DATA,
      payload: { org_deep_data: response_data.org_data },
    });
  }

  function userSelfDataFailed(errorList) {
    toast.error(errorList);
  }

  const toggleFlyoutDropdown = () => {
    setInfluencerFlyOut(!influencerFlyOut);
  };

  // filter sub category

  function FilterOutSubCategory() {
    let subCateDataList = [];
    if (categoryId) {
      subCateDataList = categoryId.flatMap(
        (item) => CampaignData.FULL_CATEGORIES.subcategories[item],
      );
    }

    return subCateDataList;
  }

  function renderFallback() {
    if (campaignStatus == "COMPLETED") {
      return (
        <>
          <div className="fall-back-center-campaign">
            <FallBackBtn
              heading="Campaign Completed"
              title="Your campaign has been completed successfully."
              text="Repost Job"
              onClick={openModalRepost}
            />
          </div>
        </>
      );
    } else if (campaignStatus == "IN_REVIEW") {
      return (
        <div className="fall-back-center-campaign">
          <FallBack
            heading={"Your campaign is under review"}
            title={"Please wait until you get a new proposal"}
          />
        </div>
      );
    } else {
      return (
        <>
          {" "}
          {searchName == null ? (
            <div className="fall-back-center-campaign">
              <FallBack
                heading={"No Proposals Available"}
                title={"Please wait until you get a new proposal"}
              />
            </div>
          ) : (
            <div className="fall-back-center-campaign">
              <SearchFallBack
                heading={"Your search did not match any results."}
                title={"Make sure all words are spelled correctly"}
                subTitle={"Try different keywords"}
              />
            </div>
          )}
        </>
      );
    }
  }
  const openModalRepost = () => {
    if (repostModal == false) {
      setRepostModal(true);
    } else {
      setRepostModal(false);
    }
  };
  const closeModalRepost = () => {
    setRepostModal(false);
  };
  // const influencerFollowersCounts = (platforms_data) => {
  //   const selectedPlatformData =
  //     platforms_data &&
  //     platforms_data?.find((item) => item.platform_id === platformId);

  //   return Utils.changeNumberToInternationalUnit(selectedPlatformData?.followers);
  // };
  // const influencerLikesCounts = (platforms_data) => {
  //   const selectedPlatformData =
  //     platforms_data &&
  //     platforms_data?.find((item) => item.platform_id === platformId);

  //   return Utils.changeNumberToInternationalUnit(selectedPlatformData?.avg_likes);
  // };
  // const influencerCommentCounts = (platforms_data) => {
  //   const selectedPlatformData =
  //     platforms_data &&
  //     platforms_data?.find((item) => item.platform_id === platformId);

  //   return Utils.changeNumberToInternationalUnit(selectedPlatformData?.avg_comments);
  // };
  // const influencerViewCounts = (platforms_data) => {
  //   const selectedPlatformData =
  //     platforms_data &&
  //     platforms_data?.find((item) => item.platform_id === platformId);

  //   return Utils.changeNumberToInternationalUnit(selectedPlatformData?.avg_views);
  // };

  const getSelectedPlatformData = (platforms_data) => {
    return platforms_data;
  };

  const formatPlatformData = (platforms_data, key) => {
    const selectedPlatformData = getSelectedPlatformData(platforms_data);
    return Utils.changeNumberToInternationalUnit(selectedPlatformData?.[key]);
  };

  const getEngagementRate = (platforms_data) => {
    const selectedPlatformData = getSelectedPlatformData(platforms_data);
    var eng_data = null;

    var eng_rate = null;
    if (selectedPlatformData?.avg_likes && selectedPlatformData?.avg_comments) {
      eng_data =
        Number(selectedPlatformData?.avg_likes) +
        Number(selectedPlatformData.avg_comments);

      eng_rate = (eng_data / Number(selectedPlatformData.avg_views)) * 100;
    }

    return eng_rate?.toFixed(1);
  };
  function getLocations(locationsData, location) {
    let result = [];
    let specifiedStates = {};
    let includedCities = {};

    if (!location || location.length == 0) {
      return locationsData;
    }

    // Identify specified states and cities
    location.forEach((locId) => {
      let item = locationsData.find((x) => x.id.toString() == locId);
      if (item) {
        if (item.type == "state") {
          specifiedStates[item.id] = true;
        } else if (item.type == "city") {
          includedCities[item.id] = true;
        }
      }
    });

    // Add all cities that belong to the specified states and the states themselves
    locationsData.forEach((item) => {
      if (item.type == "state" && specifiedStates[item.id]) {
        // Check if there are no specific cities selected for this state
        let citiesInStateSelected = location.some((locId) => {
          let city = locationsData.find(
            (x) => x.id.toString() == locId && x.type === "city",
          );
          return city && city.state_id == item.id;
        });

        if (!citiesInStateSelected) {
          result.push(item); // Add the state if no cities in it are specifically selected
        }
      } else if (
        item.type == "city" &&
        (includedCities[item.id] || specifiedStates[item.state_id])
      ) {
        if (!result.find((r) => r.id === item.id)) {
          // Check for duplicates
          result.push(item);
        }
      }
    });

    return result;
  }

  function SearchBarActive() {
    if (searchActive) {
      setSearchActive(false);
    } else {
      setSearchActive(true);
    }
  }

  function inviteListFilterFun() {
    setFilterOpen(false);
  }

  function inviteListFilterFunOpen() {
    setFilterOpen(true);
  }

  function updateGender(selectedItem) {
    setInfluencerGender(selectedItem);
    if (selectedItem.length !== 0) {
      setFilterData((prev) => {
        return {
          ...prev,
          gender: selectedItem ? selectedItem[0].value : [],
        };
      });
    }
  }
  function updateInviteMark(selectedItem) {
    setInvitedMark(selectedItem);
    if (selectedItem.length !== 0) {
      setFilterData((prev) => {
        return {
          ...prev,
          invite_mark: selectedItem ? selectedItem[0].value : [],
        };
      });
    }
  }

  const updateDeliveryDate = (date) => {
    var unixDate = Sdk.Campaign.getDateString(date);
    console.log("unixDate", unixDate);
    setDeliveryDate(unixDate);

    const storageKey = `ASSIGNMENT_DELIVERY_DATE_${campaignId}`;
    WebStorage.saveDataInWebStorage(storageKey, unixDate);
  };

  function clearFilterFun() {
    setCity([]);
    setState([]);
    setInfluencerGender([]);
    setProfession([]);
    setInvitedMark([]);

    setFilterData({
      gender: null,
      city: [],
      state: [],
      follower: [],
      category: [],
      invite_mark: null,
    });
    setClearFilter(true);
  }
  function updateState(selectedList, selectedItem) {
    var value = [];
    selectedList.forEach((item) => {
      value.push(item.id);
    });

    setFilterData((prev) => {
      return {
        ...prev,
        state: value,
      };
    });

    setState(selectedList);
  }
  function updateProfession(selectedList, selectedItem) {
    var value = [];
    selectedList.forEach((item) => {
      value.push(item.id);
    });

    setFilterData((prev) => {
      return {
        ...prev,
        profession: value,
      };
    });

    setProfession(selectedList);
  }
  function updateCity(selectedList, selectedItem) {
    var value = [];
    selectedList.forEach((item) => {
      value.push(item.id);
    });
    setFilterData((prev) => {
      return {
        ...prev,
        city: value,
      };
    });

    setCity(selectedList);
  }

  function flyoutBidListFilter() {
    return (
      <div className={`sidebar ${filterOpen ? "open" : ""}`}>
        <div className="sidebar-content-filter">
          <div
            style={{ textAlign: "right" }}
            className="cursor-pointer"
            onClick={() => inviteListFilterFun()}
          >
            <Image
              source={require("../../resources/images/bid-search-cross.png")}
            />
          </div>

          <div className="sidebar-content-filter-inner">
            <div
              style={{
                overflowX: "hidden",
                overflowY: "auto",
                height: "90%",
                paddingRight: 12,
                paddingBottom: 110,
              }}
            >
              {/* <div className="m-t-12">
                <>
                  <div style={{ gap: 5 }} className="m-b-5 flex-row">
                    <CustomText
                      p
                      fontSize={"font_size_medium"}
                      textColor={"text_color_primary"}
                      text={"Level"}
                      textAlign={"text_align_left"}
                    />
                  </div>
                  <Multiselect
                    placeholder="Select level"
                    id="css_custom"
                    options={followers}
                    selectedValues={minFollower}
                    onSelect={(selectedList, selectedItem) =>
                      updateMinFollower(selectedList, selectedItem)
                    }
                    onRemove={(selectedList, selectedItem) =>
                      updateMinFollower(selectedList, selectedItem)
                    }
                    singleSelect={false}
                    displayValue={"label"}
                    showArrow={false}
                    style={{
                      chips: Style.chips,
                      option: Style.option,
                      multiselectContainer: Style.multiselectContainerFilter,
                      searchBox: Style.searchBox,
                    }}
                  />
                </>
              </div> */}
              <div className="m-t-20">
                <div className="m-b-5">
                  <CustomText
                    p
                    fontSize={"font_size_medium"}
                    textColor={"text_color_primary"}
                    text={"Profession"}
                    textAlign={"text_align_left"}
                  />
                </div>
                <Multiselect
                  placeholder="Select profession"
                  id="css_custom"
                  selectedValues={profession}
                  options={FilterOutSubCategory()}
                  onSelect={(selectedList, selectedItem) =>
                    updateProfession(selectedList, selectedItem)
                  }
                  onRemove={(selectedList, selectedItem) =>
                    updateProfession(selectedList, selectedItem)
                  }
                  singleSelect={false}
                  displayValue={"name"}
                  showArrow={false}
                  style={{
                    chips: Style.chips,
                    option: Style.option,
                    multiselectContainer: Style.multiselectContainerFilter,
                    searchBox: Style.searchBox,
                  }}
                />
              </div>

              <div className="m-t-20">
                <div className="m-b-5">
                  <CustomText
                    p
                    fontSize={"font_size_medium"}
                    textColor={"text_color_primary"}
                    text={"Location"}
                    textAlign={"text_align_left"}
                  />
                </div>
                <Multiselect
                  placeholder="Select Location"
                  id="css_custom"
                  options={getLocations(
                    CampaignData.CITY,
                    JSON.parse(genderLocation),
                  )}
                  selectedValues={state}
                  onSelect={(selectedList, selectedItem) =>
                    updateState(selectedList, selectedItem)
                  }
                  onRemove={(selectedList, selectedItem) =>
                    updateState(selectedList, selectedItem)
                  }
                  // selectedValues={getDropdownSelectedValue(
                  //   CampaignData.LANGUAGE,
                  //   "language",
                  //   data_type
                  // )}
                  singleSelect={false}
                  displayValue={"label"}
                  showArrow={false}
                  style={{
                    chips: Style.chips,
                    option: Style.option,
                    multiselectContainer: Style.multiselectContainerFilter,
                    searchBox: Style.searchBox,
                  }}
                />
              </div>
              {/* <div className="m-t-20">
                <div className="m-b-5">
                  <CustomText
                    p
                    fontSize={"font_size_medium"}
                    textColor={"text_color_primary"}
                    text={"City"}
                    textAlign={"text_align_left"}
                  />
                </div>
                <Multiselect
                  placeholder="Select cities"
                  id="css_custom"
                  options={CampaignData.CITY.filter((item) => {
                    return item.type == "city";
                  })}
                  selectedValues={city}
                  onSelect={(selectedList, selectedItem) =>
                    updateCity(selectedList, selectedItem)
                  }
                  onRemove={(selectedList, selectedItem) =>
                    updateCity(selectedList, selectedItem)
                  }
                  singleSelect={false}
                  displayValue={"label"}
                  showArrow={false}
                  style={{
                    chips: Style.chips,
                    option: Style.option,
                    multiselectContainer: Style.multiselectContainerFilter,
                    searchBox: Style.searchBox,
                  }}
                />
              </div> */}
              {genderFilter == "all" && (
                <div style={{ textAlign: "left" }} className="m-t-20">
                  <div className="m-b-5">
                    <CustomText
                      p
                      fontSize={"font_size_medium"}
                      textColor={"text_color_primary"}
                      text={"Gender"}
                      textAlign={"text_align_left"}
                    />
                  </div>

                  <Select
                    multi={false}
                    options={options}
                    values={influencerGender}
                    onChange={(value) => updateGender(value)}
                    placeholder="Select gender"
                    autoFocus={false}
                    color="#c8c2c2"
                    // Customcolor
                    style={{
                      border: "1px solid rgb(230, 231, 232)",
                      backgroundColor: "#fff",
                      borderRadius: 4,
                      paddingBottom: "12px",
                      paddingTop: "12px",
                      option: {
                        backgroundColor: "red",
                      },
                    }}
                  />

                  {/* <BorderedDropdown invert placeholder={"Choose gender"} /> */}
                </div>
              )}
              <div style={{ textAlign: "left" }} className="m-t-20">
                <div className="m-b-5">
                  <CustomText
                    p
                    fontSize={"font_size_medium"}
                    textColor={"text_color_primary"}
                    text={"Invited"}
                    textAlign={"text_align_left"}
                  />
                </div>

                <Select
                  multi={false}
                  options={inviteOption}
                  values={invitedMark}
                  onChange={(value) => updateInviteMark(value)}
                  placeholder="Please select"
                  autoFocus={false}
                  color="#c8c2c2"
                  // Customcolor
                  style={{
                    border: "1px solid rgb(230, 231, 232)",
                    backgroundColor: "#fff",
                    borderRadius: 4,
                    paddingBottom: "12px",
                    paddingTop: "12px",
                    option: {
                      backgroundColor: "red",
                    },
                  }}
                />

                {/* <BorderedDropdown invert placeholder={"Choose gender"} /> */}
              </div>

              {/* <div style={{ textAlign: "left" }} className="m-t-20">
                <div className="m-b-5">
                  <CustomText
                    p
                    fontSize={"font_size_medium"}
                    textColor={"text_color_primary"}
                    text={"Has counter offer"}
                    textAlign={"text_align_left"}
                  />
                </div>

                <Select
                  multi={false}
                  options={counterOption}
                  values={counterCheck}
                  onChange={(value) => updateCounterFilter(value)}
                  placeholder="Counter"
                  autoFocus={false}
                  color="#c8c2c2"
                  // Customcolor
                  style={{
                    border: "1px solid grey",
                    backgroundColor: "#fff",
                    borderRadius: 4,
                    paddingBottom: "12px",
                    paddingTop: "12px",
                    option: {
                      backgroundColor: "red",
                      zIndex: 999999,
                    },
                  }}
                />
              </div> */}
            </div>
            <div className="filter-status-bottom-container">
              <div>
                <PrimaryCta
                  fifth
                  onClick={() => getBidList()}
                  fontSize={"font_size_large"}
                  text={"Apply Filter"}
                  isLoading={""}
                />
              </div>
              <div>
                <PrimaryCta
                  invertSmall
                  onClick={() => clearFilterFun()}
                  fontSize={"font_size_large"}
                  text={"Clear Filter"}
                  isLoading={""}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function openModalCollection() {
    if (modalIsOpenCollection == false) {
      setModalIsOpenCollection(true);
    } else {
      setModalIsOpenCollection(false);
    }
  }

  function closeModalCollection() {
    setModalIsOpenCollection(false);
  }
  function openModalCollectionGrid() {
    if (modalIsOpenCollectionGrid == false) {
      setModalIsOpenCollectionGrid(true);
    } else {
      setModalIsOpenCollectionGrid(false);
    }
  }

  function closeModalCollectionGrid() {
    setModalIsOpenCollectionGrid(false);
  }

  const handleMouseEnterCollection = (id) => {
    setIsHovered(true);
  };

  const handleMouseLeaveCollection = () => {
    setIsHovered(false);
  };

  function hoveredButton() {
    return (
      <button
        onClick={openModalCollectionGrid}
        className={`button-hover-show-btn ${
          showCollectionBtn ? "hidden-hover-show-btn" : ""
        }`}
      >
        Add to Collection
      </button>
    );
  }

  const influencerTableSchema = [
    {
      name: "Influencer Name",
      selector: (row) => row["influencer_data"]["name"],

      cell: (data) => (
        <span
          onClick={(e) => {
            toggleFlyoutDropdown();
            setInfluencerId(data?.influencer_data.influencer_id);
          }}
          style={{ display: "flex", gap: 8, alignItems: "center" }}
        >
          <Image
            source={
              data.influencer_data.profile_picture
                ? Utils.generateInfluencerDpUrl(
                    data.influencer_data.influencer_id,
                    data.influencer_data.profile_picture,
                  )
                : require("../../resources/images/user-copy.png")
            }
            className="proposal-user-profile"
          />
          <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
            <div>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  gap: 5,
                  alignItems: "baseline",
                }}
              >
                <CustomText
                  p
                  text={data.influencer_data.name}
                  className="Body-1"
                />
                {/* <div>
                  <CustomText
                    p
                    text={`(${data.influencer_data.ratings.toFixed(1)})`}
                    className="typographyH5"
                  />
                </div> */}
              </div>
              <CustomText
                p
                text={getInflencerLocation(data?.influencer_data)}
                fontSize={"font_size_extraSmall"}
                fontWeight={"rubik_regular"}
                textColor={"text_color_primary"}
                textAlign={"text_align_left"}
              />
            </div>
          </div>
        </span>
      ),
      width: "250px",
    },
    {
      name: "Platform",
      selector: (row) =>
        platFormName(row.platforms_data, row.influencer_data.influencer_id),
      // sortable: true,
      width: "100px",
    },
    {
      name: "Followers",
      selector: (row) => formatPlatformData(row.platforms_data, "followers"),

      width: "150px",
    },
    // {
    //   name: "Like",
    //   selector: (row) => formatPlatformData(row.platforms_data, "avg_likes"),
    //   width: "90px",
    // },
    // {
    //   name: "Comment",
    //   selector: (row) => formatPlatformData(row.platforms_data, "avg_comments"),
    //   width: "90px",
    // },
    {
      name: "Avg Views",
      selector: (row) =>
        Utils.isObjectOrNullUndefinedZero(
          formatPlatformData(row.platforms_data, "avg_views"),
        )
          ? "-"
          : formatPlatformData(row.platforms_data, "avg_views"),
      width: "100px",
    },
    {
      name: "ER",
      selector: (row) =>
        Utils.isNullOrUndefinedOrZero(
          formatPlatformData(row.platforms_data, "engagement_rate"),
        )
          ? "-"
          : formatPlatformData(row.platforms_data, "engagement_rate"),
      width: "130px",
      cell: (data) => (
        <span>
          <Tooltip
            title={
              <>
                <div>
                  Avg Likes ={" "}
                  {formatPlatformData(data.platforms_data, "avg_likes")}
                </div>
                <div>
                  Avg Comments ={" "}
                  {formatPlatformData(data.platforms_data, "avg_comments")}
                </div>
              </>
            }
          >
            {Utils.isNullOrUndefinedOrZero(
              Number(
                formatPlatformData(data.platforms_data, "engagement_rate"),
              ),
            )
              ? "-"
              : Number(
                  formatPlatformData(data.platforms_data, "engagement_rate"),
                ).toFixed(2) + " %"}
          </Tooltip>
        </span>
      ),
    },

    {
      name: "",
      // lastCol: true,
      // paddingRight: "20px",
      conditionalCellStyles: [
        {
          when: (row) => true,
          style: {
            justifyContent: "right",
          },
        },
      ],
      cell: (data) => (
        <snap
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
          }}
        >
          <>
            {inviteAndReject(data?.influencer_data?.influencer_id) ? (
              <CustomButton
                onClick={() =>
                  postInfluencerInviteWithdraw(
                    data?.influencer_data?.influencer_id,
                  )
                }
                disabled={true}
                fontSize={"font_size_small"}
                text={"Invited"}
                isLoading={""}
                borderRadius={4}
                padding={{ top: 10, right: 16, bottom: 10, left: 16 }}
                textColor={"text_color_light"}
                background={"#B3B3B6"}
                border={"none"}
                boxShadow={"none"}
                hoverColor={"var(--hover-color, #1977F2)"}
              />
            ) : (
              <PrimaryCta
                fifth
                onClick={() =>
                  postInfluencerInvite(data?.influencer_data?.influencer_id)
                }
                iconName="InviteIcon"
                iconPosition="left"
                text={"Invite"}
                isLoading={
                  isInviteLoading[data?.influencer_data?.influencer_id]
                }
              />
              // <CustomButton
              //   iconName="InviteIcon"
              //   onClick={() =>
              //     postInfluencerInvite(data?.influencer_data?.influencer_id)
              //   }
              //   fontSize={"font_size_small"}
              //   text={"Invite"}
              //   isLoading={
              //     isInviteLoading[data?.influencer_data?.influencer_id]
              //   }
              //   borderRadius={4}
              //   padding={{ top: 10, right: 16, bottom: 10, left: 16 }}
              //   textColor={"text_color_light"}
              //   background={"#090A14"}
              //   border={"none"}
              //   boxShadow={"none"}
              //   hoverColor={"var(--hover-color, #1977F2)"}
              // />
            )}
          </>
          <PrimaryCta
            invertSmall
            text={"Add to Collection"}
            onClick={() => {
              setHoveredId(data.influencer_data.influencer_id);
              openModalCollectionGrid();
            }}
          />
          {/* <div
            onClick={() => {
              setHoveredId(data.influencer_data.influencer_id);
              openModalCollectionGrid();
            }}
            style={{ textWrap: "nowrap", fontSize: "bold" }}
          >
            <CustomText
              p
              bold
              text={"Add to Collection"}
              fontWeight={"rubik_regular"}
              textColor={"text_color_secondary"}
            />
          </div> */}
        </snap>
      ),
    },

    {
      name: "",
      // lastCol: true,
      cell: (data) => (
        <snap
          style={{
            alignItems: "center",
          }}
        >
          <PrimaryCta
            fifth
            onClick={(index) => {
              //  setBidId(data.influencer_data.influencer_id);
              // balanceValidation(data.bid_data.value);
              // setBidValue(data.bid_data.value);
              setInfluencerId(data.influencer_data.influencer_id);
              openModal();
            }}
            fontSize={"font_size_large"}
            text={"Assignment"}
          />
          {/* <CustomButton
            onClick={(index) => {
              //  setBidId(data.influencer_data.influencer_id);
              // balanceValidation(data.bid_data.value);
              // setBidValue(data.bid_data.value);
              setInfluencerId(data.influencer_data.influencer_id);
              openModal();
            }}
            fontSize={"font_size_large"}
            text={"Assignment"}
            // isLoading={approveCampaign[data.bid_data.bid_id]}
            borderRadius={4}
            padding={{ top: 10, right: 10, bottom: 10, left: 10 }}
            textColor={"text_color_light"}
            background={"#090A14"}
            border={"none"}
            boxShadow={"none"}
            hoverColor={"var(--hover-color, #1977F2)"}
          /> */}
        </snap>
      ),
    },
  ];

  function renderInviteList() {
    if (totalRows !== 0) {
      const paginationTotal =
        typeof totalRows === "number" && Number.isFinite(totalRows)
          ? totalRows
          : 0;
      const tablePending = isLoading || totalRows === null;
      return (
        <div className="">
          <CustomTable
            className="CustomTable"
            tableSchema={influencerTableSchema}
            paginationPerPage={10}
            tableData={influencerList.length == 0 ? [] : influencerList}
            rowPaddingTop={16}
            rowPaddingBottom={16}
            customStyles={customBidStyles}
            // conditionalRowStyles={conditionalRowStyles}
            progressPending={tablePending}
            paginationTotalRows={paginationTotal}
            // onChangeRowsPerPage={getInfluencerListChange}
            onChangePage={handlePageChange}
            // onRowClicked={(item) =>
            //   CampaignClick(item.campaign_data.campaign_id)
            // }
            progressComponent={
              <div className="fall-back-center-campaign">
                <Loader />
              </div>
            }
            paginationServer
            pagination
          />
        </div>
      );
    } else if (isLoading || !influencerList) {
      return <Loader />;
    } else if (!isLoading && influencerList.length == 0) {
      return (
        <div className="fall-back-center-campaign">
          <FallBack
            heading={"No influencer available"}
            title={"No influencer in your demographic criteria."}
          />
        </div>
      );
    }
  }

  function inviteAndReject(id) {
    let inviteId = influencerInviteList.find(
      (item) => item.influencer_id == id,
    );
    return inviteId;
  }

  const platFormName = (platforms_data, influencer_id) => {
    const handleMouseEnter = (index) => {
      const newHoveredIcons = [...hoveredIcons];
      newHoveredIcons[index] = true;
      setHoveredIcons(newHoveredIcons);
    };

    const handleMouseLeave = (index) => {
      const newHoveredIcons = [...hoveredIcons];
      newHoveredIcons[index] = false;
      setHoveredIcons(newHoveredIcons);
    };

    const platformData = platforms_data;

    console.log("platformId k", platformData);

    const handlePlatformClick = (url) => {
      // Open the platform URL here
      window.open(url, "_blank");
      // Reset all hover states to false after clicking
      setHoveredIcons(new Array(platforms_data.length).fill(false));
    };

    return (
      <>
        {platforms_data.length > 0 &&
          platformData &&
          platforms_data[0].platform_id != null && (
            <div>
              {/* <CustomText
              p
              text={"Social Presence"}
              fontSize={"font_size_small"}
              textColor={"text_color_black"}
              fontWeight={"Poppins_semiBold"}
            /> */}
            </div>
          )}
        <div style={{ marginTop: 7 }} className="flex-row">
          <div
            className={"platform-name"}
            onMouseEnter={() =>
              handleMouseEnter(`${influencer_id}${platformData?.platform_id}`)
            }
            onMouseLeave={() =>
              handleMouseLeave(`${influencer_id}${platformData.platform_id}`)
            }
            onClick={() =>
              handlePlatformClick(
                Utils.getSocialUrl(
                  platformData?.platform_id,
                  platformData?.identifier_id,
                ),
              )
            }
          >
            {platformData?.platform_id && (
              <Icon
                iconName={
                  hoveredIcons[`${influencer_id}${platformData?.platform_id}`]
                    ? Utils.getSocialIconHover(platformData?.platform_id)
                    : Utils.getSocialIcon(platformData?.platform_id)
                }
                height={14}
                width={14}
              />
            )}
          </div>
        </div>
      </>
    );
  };

  function getInflencerLocation(influencer_data) {
    if (influencer_data["city_id"]) {
      return CampaignData.CITY.find(
        (city) => city.id == influencer_data["city_id"],
      )?.label;
    } else if (influencer_data["state"]) {
      return CampaignData.LOCATIONS[influencer_data["state"]]?.n;
    } else {
      return "-";
    }
  }

  function filterDropDownOpenClose() {
    if ((sortBy != null) & (sortOrder != null)) {
      setSortBy(null);
      setSortOrder(null);
      setFilterLabel(null);
    } else {
      SortDropDown();
    }
  }

  function SortDropDown() {
    if (filterDropDown) {
      setFilterDropDown(false);
    } else {
      setFilterDropDown(true);
    }
  }

  const openModal = () => {
    if (modalIsOpen == false) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen(false);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  function renderAssignmentSignModal() {
    return (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={CancelReminder}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "#ffffff",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <div onClick={closeModal} className="close-btn-icon">
            <Icon iconName="CloseRoundButtonIcon" />
          </div>

          <CustomText
            p
            text={"Create Assignment"}
            textColor={"text_color_primary"}
            fontSize={"font_size_2xl"}
            className="typographyH7"
          />
        </div>
        <div className="create-assignment-container">
          <div className="create-assignment-inner-container">
            <div className="create-assignment-inner-container">
              <div className="m-b-8 m-l-10">
                <CustomText
                  p
                  fontSize={"font_size_medium"}
                  textColor={"text_color_primary"}
                  text={"Reward Amount"}
                />
              </div>
              <CustomTextInput
                invert
                placeholder={"Reward Amount"}
                value={maxRewardValue}
                onChange={(e) =>
                  setMaxRewardValue(e.target.value.replace(/\D/g, ""))
                }
              />
            </div>
            <div className="m-t-12 full-width create-assignment-inner-container">
              <div className="m-b-8 m-l-10">
                <CustomText
                  p
                  fontSize={"font_size_medium"}
                  textColor={"text_color_primary"}
                  text={"Delivery Date"}
                />
              </div>
              <DatePicker
                className={"react-datepicker-size-assignment "}
                selected={moment.unix(deliveryDate).toDate()}
                onChange={(date) => updateDeliveryDate(date)}
                format="dd-MM-y"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingTop: 20,
            }}
          >
            <button
              style={{ color: "#090a14" }}
              className="confirm-btn-bid "
              onClick={closeModal}
            >
              Close
            </button>
            <div className=" m-l-32">
              <PrimaryCta
                fifth
                onClick={() => createAssignmentAdmin()}
                fontSize={"font_size_large"}
                className="collection-create-btn"
                text={"Create Assignment"}
                isLoading={isLoading}
                //   disabled={!collectionId}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <div style={{ minHeight: 500 }}>
      <>
        <div className="bid-list-dropdown-header-container">
          <div>
            {!isLoading &&
              totalRows !== null &&
              Number.isFinite(totalRows) &&
              totalRows > 0 && (
              <div
                style={{ marginTop: 12 }}
                className="flex-row justify-between align-center"
              >
                <CustomText
                  p
                  text={"Top "}
                  fontSize={"font_size_regular"}
                  textColor={"text_color_primary"}
                  fontWeight={"Poppins_regular_medium"}
                />
                &nbsp;
                <CustomText
                  p
                  text={`${start + 1}-${totalRows} Results`}
                  fontSize={"font_size_regular"}
                  textColor={"text_color_primary"}
                  fontWeight={"Poppins_regular"}
                />
              </div>
            )}
          </div>
          <div className="flex-row" style={{ display: "flex", gap: 5 }}>
            <div className="dropdown-button-container">
              <button
                onClick={() => filterDropDownOpenClose()}
                className="dropdown-button"
              >
                <CustomText
                  p
                  text={filterLabel ? filterLabel : "Sort by"}
                  fontSize={"font_size_regular"}
                  textColor={"text_color_black"}
                  textAlign={"text_align_right"}
                />
                {filterLabel ? (
                  <div className="cursor-pointer">
                    <Image
                      source={require("../../resources/images/bid-search-cross.png")}
                    />
                  </div>
                ) : (
                  <div className="cursor-pointer">
                    <Icon iconName={"DropdownIcon"} height={18} width={18} />
                  </div>
                )}
              </button>
              {filterDropDown && (
                <div className="dropdown-list-container-invite">
                  {sortTypes.map((item) => {
                    return (
                      <div
                        onClick={() => {
                          setNext(0);
                          setSortBy(item.sortBy);
                          setSortOrder(item.sortOrder);
                          SortDropDown();
                          setFilterLabel(item.label);
                        }}
                        className={
                          item.sortBy == sortBy && item.sortOrder == sortOrder
                            ? "dropdown-button-list-selected"
                            : "dropdown-button-list"
                        }
                      >
                        {item.label}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div
              className="filter-icon-btn-invite"
              onClick={() => inviteListFilterFunOpen()}
            >
              <Icon iconName="filterIcon" />
            </div>
          </div>
        </div>
        {campaignStatus == "ACTIVE" ? (
          <>
            {renderInviteList()}

            {modalIsOpen && renderAssignmentSignModal()}
          </>
        ) : (
          <div className="fall-back-center-campaign">
            <FallBack
              heading={"No influencer available"}
              title={"No influencer in your demographic criteria."}
            />
          </div>
        )}

        {/* {isLoading ? (
          <div className="fall-back-center-campaign">
            <Loader />
          </div>
        ) : (
          <>
            {campaignDetail?.campaign_data?.status !== "IN_REVIEW" ? (
              <div>
                <>
                  {isLoading && influencerList.length == 0 ? (
                    <div className="fall-back-center-campaign">
                      <FallBack
                        heading={"No influencer available"}
                        title={"No influencer in your demographic criteria."}
                      />
                    </div>
                  ) : (
                    <div className="custom-table-bid">
                      <CustomTable
                        className="CustomTable"
                        tableSchema={influencerTableSchema}
                        paginationPerPage={15}
                        tableData={
                          influencerList.length == 0 ? [] : influencerList
                        }
                        rowPaddingTop={16}
                        rowPaddingBottom={16}
                        customStyles={customBidStyles}
                        conditionalRowStyles={conditionalRowStyles}
                        progressPending={isLoading}
                        // onChangePage={() => getInfluencerList(next, updateProgress)}
                        // onRowClicked={(item) =>
                        //   CampaignClick(item.campaign_data.campaign_id)
                        // }
                        progressComponent={
                          <div className="fall-back-center-campaign">
                            <Loader />
                          </div>
                        }
                        pagination
                      />
                    </div>
                  )}
                </>
              </div>
            ) : (
              <div className="fall-back-center-campaign">
                <FallBack
                  heading={"No influencer available "}
                  title={"No influencer in your demographic criteria."}
                />
              </div>
            )}
          </>
        )} */}
      </>
      {filterOpen && flyoutBidListFilter()}
      {modalIsOpenCollectionGrid && (
        <CreateCollectionGrid
          closeModal={closeModalCollectionGrid}
          id={hoveredId}
          campaignId={campaignId}
          // orgId={orgId}
          // brandId={brandId}
        />
      )}
      {/* {influencerFlyOut && } */}
    </div>
  );
}

export default InviteList;

const CancelReminder = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "var(--general-secondary-color)",
    textAlign: "center",
    zIndex: "5",
    height: "40%",
    display: "flex",
    flexDirection: "column",
    minHeight: "400px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.95)",
    zIndex: 10,
  },
};
